import { USER_MODULE } from '../../configs/moduleNames';
import UserDTO from '../../dto/UserDTO';

export const MODULE_NAME = USER_MODULE;
export const MODULE_BACK_PATH = 'users';
export const MODULE_MAIN_PAGE = '/users/';
export const MODULE_DTO = UserDTO;
